// 画面表示前にアセットを先読みするための共通ヘルパー。

// 画像をデコード完了まで先読みする。読み込み失敗時も画面を止めないため常に解決する。
export const preloadImage = (src: string): Promise<void> =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      // decode() まで待つことで、貼り付けた瞬間に描画が間に合わない状態を避ける
      if (img.decode) {
        img.decode().then(() => resolve(), () => resolve());
      } else {
        resolve();
      }
    };
    img.onerror = () => resolve();
    img.src = src;
  });

// 指定時間内に終わらなければ待つのをやめる。アセットが壊れていても画面を止めないため。
export const withTimeout = <T,>(promise: Promise<T>, ms: number): Promise<T | void> => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const timeout = new Promise<void>((resolve) => {
    timeoutId = setTimeout(resolve, ms);
  });

  return Promise.race([promise, timeout]).finally(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  });
};
